import * as React from 'react';
import {
  GqlStaff,
  UserRole,
  StaffRole,
} from '../../core/gql/queries/show-all-staff';
import {
  formatRoleForDisplay,
  roleFromString,
  compareRoles,
  Role,
  roleScope,
} from 'auth';
import { capitalize } from '../../core/utils';

const staffRow = (
  staff: GqlStaff,
  organizationId: number,
  actionColumn: React.ReactElement,
  queryPrograms: any,
  pidx: number
) => {
  const createSortableValues = (staffList: StaffRole[], type: string): string =>
    staffList.reduce((prev, curr) => prev + curr[type], '');

  const staffRoles =
    [...staff?.staffRoles].sort((roleA: StaffRole, roleB: StaffRole) =>
      compareRoles(roleA.type, roleB.type)
    ) ?? [];

  const staffRolesFlat = staffRoles
    .map((role) => {
      if (roleScope(role.type) == 'program') {
        return role.programs.map((program) => ({ ...role, program: program }));
      } else {
        return role;
      }
    })
    .flat();

  return {
    id: parseInt(pidx + '' + staff.id),
    col1: (
      <div key={`${staff.firstName}-${staff.lastName}-${staff.id}`}>
        <div>
          {staff.firstName} {staff.lastName}
        </div>
      </div>
    ),
    col2: (
      <div key={`${createSortableValues(staffRoles, 'type')}-${staff.id}`}>
        {staffRolesFlat.map(
          (role, index) =>
            role && (
              <div key={`${role.organizationId}-${index}`}>
                <span>{formatRoleForDisplay(roleFromString(role.type))}</span>
                {roleScope(role.type) == 'program' && (
                  <span>
                    <strong>&nbsp;&middot;&nbsp;</strong>
                    <span>{role.program?.name}</span>
                  </span>
                )}
                {roleScope(role.type) == 'division' && (
                  <span>
                    <strong>&nbsp;&middot;&nbsp;</strong>
                    <span>{role.season?.name}</span>
                    <strong>&nbsp;&middot;&nbsp;</strong>
                    <span>
                      {role.divisions
                        .map((division) => division?.name)
                        .join(', ')}
                    </span>
                  </span>
                )}
              </div>
            )
        )}
      </div>
    ),
    col3: (
      <div key={`${staff.emailAddress}-${staff.id}`}>
        <div>{staff.emailAddress}</div>
        <div>{staff.phoneNumber}</div>
      </div>
    ),
    col4: (
      <div key={`${staff.invitationStatus.toString()}-${staff.id}`}>
        {capitalize(staff.invitationStatus.toLowerCase())}
      </div>
    ),
    col5: actionColumn,
  };
};

export default staffRow;
